import { render, staticRenderFns } from "./ProgramAddress.vue?vue&type=template&id=74205808&scoped=true&"
import script from "./ProgramAddress.vue?vue&type=script&lang=js&"
export * from "./ProgramAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74205808",
  null
  
)

export default component.exports